import * as actionTypes from '../actions/actionTypes';

const initialState = {
  show_sliding_window: false,
  sliding_window_title: null,
  sliding_window_content: null,
  sliding_window_onClose: null,
  company: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMPANY:
      return {
        ...state,
        company: action.company
      };
    case actionTypes.TOGGLE_SLIDING_WINDOW:
      return {
        ...state,
        show_sliding_window: !state.show_sliding_window
      };
    case actionTypes.SET_SLIDING_WINDOW:
      return {
        ...state,
        sliding_window_content: action.content,
        sliding_window_title: action.title,
        sliding_window_onClose: action.onClose
      };
    default:
      return state;
  }
};

export default reducer;
